import React, {createContext, useReducer} from 'react'

const Reducer = (state, action) => {
    switch (action.type) {
        case 'INITIALIZECONFIG':
            return {
                ...state,
                version : action.payload.version,
                useEmail : getBoolFromString(action.payload.useEmail),
                baseUrl : action.payload.baseUrl,
                isSSOAutoRedirect: getBoolFromString(action.payload.isSSOAutoRedirect),
                hasSSO: getBoolFromString(action.payload.hasSSO),
                showPasswordLogin: getBoolFromString(action.payload.showPasswordLogin),
                myPrequestUrl: action.payload.myPrequestUrl
            };
        case 'SETRETURNURL':
            return {
                ...state,
                returnUrl : action.payload
            };
        case 'SETUSER':
            return {
                ...state,
                user : action.payload
            };
        case 'SETLOCKOUTTIME':
            return {
                ...state,
                lockoutTime: action.payload,
            }
        case 'SETUSERMANAGEMENTSEARCH':
            return {
                ...state,
                userManagement: {
                    ...state.userManagement,
                    searchValue: action.payload
                }
            }
        case 'SETUSERMANAGEMENTFILTERS':
            return {
                ...state,
                userManagement: {
                    ...state.userManagement,
                    filters:action.payload.filters,
                    sorter:action.payload.sorter
                }
            }
        default:
            return state;
    }
};

function getBoolFromString(stringValue){
    return JSON.parse(stringValue)
}

const initialState = {
    version: "unknown",
    useEmail: false,
    baseUrl: "unknown",
    isSSOAutoRedirect: false,
    hasSSO: false,
    user: {},
    showPasswordLogin: true,
    returnUrl: undefined,
    lockoutTime: 15,
    userManagement: {
        searchValue: "",
        filters: {},
        sorter: {
            columnKey: "person",
            order: "ascend"
        }
    },
    myPrequestUrl: "../../../myprequest"
};

const AppContext = ({children}) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    
    return (
        <appContext.Provider value={[state, dispatch]}>
            {children}
        </appContext.Provider>
    )
};


export const appContext = createContext(initialState);
export default AppContext;